import React, { createContext, useState, useEffect, useContext } from 'react';

import zakazky from '../_mock/zakazky';
import {
  addZakazkaService,
  deleteZakazkaService,
  editZakazkaService,
  fetchZakazky,
  removeFileService,
  uploadFilesService,
} from './zakazkyServices';
import { useAlert } from '../hooks/useAlert';
import { UserContext } from './userContext';
import { useNavigate } from 'react-router-dom';
import { numberDescendingComparator } from 'src/pages/zakazky/ZakazkyList.page';

export const ZakazkyContext = createContext();

export const ZakazkyProvider = ({ children }) => {
  const [zakazky, setZakazky] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { error: errorAlert, confirm, success } = useAlert();
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const addZakazka = async (item) => {
    try {
      const newZakazka = await addZakazkaService(item);
      const id = newZakazka?.data?.data?.id;
      setZakazky((prev) => [{ id, ...item }, ...prev]);
      const successed = await success('Zákazka bola pridaná');
      if (successed.isConfirmed) {
        navigate(`/sprava/zakazky/detail/${id}`);
      }
    } catch (err) {
      console.log(err);
      errorAlert('Nepodarilo sa pridať Zákazku.');
    }
  };

  const uploadFiles = async (id, files) => {
    let fileData = new FormData();
    for (let i = 0; i < files.length; i++) {
      fileData.append(`files[]`, files[i]);
    }
    try {
      const newFiles = await uploadFilesService(id, fileData);
      setZakazky((prev) =>
        prev.map((zakazka) => {
          if (zakazka.id === id) {
            return { ...zakazka, files: [...zakazka?.files, ...files] };
          }
          return zakazka;
        })
      );
      const successed = await success('Súbory bola pridané');
      if (successed.isConfirmed) {
        navigate(`/sprava/zakazky/detail/${id}`);
      }
    } catch (err) {
      console.log(err);
      errorAlert('Nepodarilo sa pridať súbory.');
    }
  };

  const editZakazka = async (zakazkaId, editedZakazka) => {
    try {
      const editZakazka = await editZakazkaService(zakazkaId, editedZakazka);
      setZakazky((prev) =>
        prev.map((zakazka) => {
          if (zakazka.id === zakazkaId) {
            return { ...zakazka, ...editedZakazka };
          }
          return zakazka;
        })
      );
      await success('Zakázka bola upravená');
      window.location.reload();
    } catch (err) {
      console.log(err);
      errorAlert('Nepodarilo sa upraviť zakázku.');
    }
  };

  const removeZakazka = async (id) => {
    const confirmation = await confirm('Prajete si vymazať zakázku?', 'Vymazať');
    if (confirmation.isConfirmed) {
      try {
        const deletedZakazka = await deleteZakazkaService(id);
        setZakazky((prev) => prev.filter((item) => item.id !== id));
        success('Zákazka bola vymazaná');
      } catch (err) {
        errorAlert('Nepodarilo sa vymazať zakázku.');
      }
    }
  };

  const removeFile = async (idZakazka, idFile) => {
    const confirmation = await confirm('Prajete si vymazať súbor?', 'Vymazať');
    if (confirmation.isConfirmed) {
      try {
        const deletedFile = await removeFileService(idFile);
        setZakazky((prev) =>
          prev.map((zakazka) => {
            if (zakazka.id === idZakazka) {
              const files = zakazka?.files.filter((file) => file.id !== idFile);
              return { ...zakazka, files };
            }
            return zakazka;
          })
        );
        await success('Súbor bol vymazaný');
        window.location.reload();
      } catch (err) {
        errorAlert('Nepodarilo sa vymazať súbor.');
      }
    }
  };

  const getZakazky = async () => {
    setLoading(true);
    try {
      const response = await fetchZakazky();
      const data = await response.data;
      setLoading(false);
      setZakazky(data);
    } catch (err) {
      setLoading(false);
      setError(err);
    }
  };

  useEffect(() => {
    getZakazky();
  }, [user]);

  return (
    <ZakazkyContext.Provider
      value={{ loading, zakazky, error, addZakazka, removeZakazka, editZakazka, uploadFiles, removeFile }}
    >
      {children}
    </ZakazkyContext.Provider>
  );
};
